var Backbone = require("../../libs/backbone/backbone");
var GenericModel = require("./generic.model.ts");

var AgentsModel = GenericModel.extend(
{

urlRoot : '/rest/api/agents',
id : null,

});

module.exports = AgentsModel;